// use this instead of DeferredPromise/DeferredPromiseFactory, because it has better typing, and is not just for tests
export class ApDeferred<TResult, TError = Error> {
  readonly promise: Promise<TResult>;
  private _resolve: (value: TResult | PromiseLike<TResult>) => void;
  private _reject: (reason: TError) => void;

  constructor() {
    this.promise = new Promise<TResult>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  resolve(value: TResult | PromiseLike<TResult>): this {
    this._resolve(value);
    return this;
  }

  reject(reason: TError): this {
    this._reject(reason);
    return this;
  }
}
